
$(document).ready(function () {
	if (window.innerWidth >= 970) {
		$('.virtual-tour-item .virtual-tour-item-pulse').popover({
			trigger: 'manual',
			html: true,
			placement: 'top',
			content: function () {
				return $($(this).next('.virtual-tour-item-popover')).html();
			}
		})
			.on('shown.bs.popover', function () {
				// when popover renders, init the modal js
				initModal();
			})
			.on('mouseenter', function () {
				var _this = this;
				$(this).popover('show'); 

				$('.popover').on('mouseleave', function () {
					$(_this).popover('hide');
				});
			})
			.on('mouseleave', function () {
				var _this = this;

				setTimeout(function () {
					if (!$('.popover:hover').length) {
						$(_this).popover('hide');
					}
				}, 300);
			});
	}
	else {
		$('.virtual-tour-item .virtual-tour-item-pulse').popover({
			trigger: 'click',
			html: true,
			placement: 'top',
			content: function () {
				return $($(this).next('.virtual-tour-item-popover')).html();
			}
			})
			.on('shown.bs.popover', function () {
				// when popover renders, init the modal js
				initModal();
			});
	}

	function initModal() {
		$('.popup-modal').magnificPopup({
			type: 'inline',
			preloader: false,
			modal: true,
			callbacks: {
				open: function () {
					initCarousel();
					$('.virtual-tour-item .virtual-tour-item-pulse').popover('hide')
				}
			}
		});

		$(document).on('click', '.popup-modal-dismiss', function (e) {
			e.preventDefault();
			$.magnificPopup.close();
		});
	}

	function initCarousel() {
		if ($('.js-modal-carousel').hasClass('slick-initialized')) {
			$('.js-modal-carousel').slick('unslick');
		}
	
		$('.js-modal-carousel').each(function () {
			var slickInduvidual = $(this);
			if (slickInduvidual.length) {
				slickInduvidual.slick({
					dots: true,
					slidesToShow: 1,
					slide: '.carousel-offset-item',
					arrows: true,
					nextArrow: '<span class="fal fa-long-arrow-right"></span>',
					prevArrow: '<span class="fal fa-long-arrow-left"></span>', 
					appendArrows: $(this).find('.carousel-offset-arrows')
				});
			}
		});
	}
});